import script from "./ContestedRuns.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContestedRuns.vue?vue&type=script&setup=true&lang=ts"

import "./ContestedRuns.vue?vue&type=style&index=0&id=cd91a5e2&scoped=true&lang=css"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd91a5e2"]])

export default __exports__